<script lang="ts" setup>
// #兩張圖片，上下排列
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_top)
  const img2: Ref<Image> = ref(props.data.image_bottom)
  imgData1.value = img1.value
  imgData2.value = img2.value
}
</script>

<template>
  <div class="area">
    <figure class="area__pic area__top">
      <Nimg :src="imgData1?.link" :title="imgData1?.title" :alt="imgData1?.alt" format="webp" />
    </figure>
    <figure class="area__pic area__bottom">
      <Nimg :src="imgData2?.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__pic {
    width: 74%;

    img {
      display: block;
      width: 100%;
    }
  }

  &__top {
    margin-bottom: toRem(20);
  }

  &__bottom {
    margin-left: auto;
  }
}
</style>
